export type BillingPresentationState = {
    kind: 'trial';
    requiresPaymentMethodUpdate: boolean;
} | {
    kind: 'paid';
    requiresPaymentMethodUpdate: boolean;
} | {
    kind: 'payment_pending';
    requiresPaymentMethodUpdate: boolean;
} | {
    kind: 'payment_failed';
    requiresPaymentMethodUpdate: boolean;
} | {
    kind: 'inactive';
    requiresPaymentMethodUpdate: boolean;
} | {
    kind: 'unknown';
    requiresPaymentMethodUpdate: boolean;
};

export interface BillingPresentationStateInput {
    provider?: string | null;
    subscriptionStatus?: string | null;
    requiresPaymentMethodUpdate?: boolean | null;
}

export const resolveBillingPresentationState = ({
    provider,
    subscriptionStatus,
    requiresPaymentMethodUpdate,
}: BillingPresentationStateInput): BillingPresentationState => {
    const paymentMethodUpdateRequired = Boolean(requiresPaymentMethodUpdate);
    const normalizedProvider = provider?.trim().toLowerCase();
    const normalizedSubscriptionStatus = subscriptionStatus?.trim().toLowerCase();

    if (normalizedProvider !== 'stripe') {
        return { kind: 'unknown', requiresPaymentMethodUpdate: paymentMethodUpdateRequired };
    }

    switch (normalizedSubscriptionStatus) {
        case 'trial':
        case 'trialing':
            return { kind: 'trial', requiresPaymentMethodUpdate: paymentMethodUpdateRequired };
        case 'active':
        case 'paid':
        case 'pending_cancellation':
            return { kind: 'paid', requiresPaymentMethodUpdate: paymentMethodUpdateRequired };
        case 'incomplete':
        case 'pending':
        case 'processing':
            return { kind: 'payment_pending', requiresPaymentMethodUpdate: paymentMethodUpdateRequired };
        case 'past_due':
        case 'unpaid':
        case 'incomplete_expired':
            return { kind: 'payment_failed', requiresPaymentMethodUpdate: paymentMethodUpdateRequired };
        case 'canceled':
        case 'cancelled':
        case 'expired':
            return { kind: 'inactive', requiresPaymentMethodUpdate: paymentMethodUpdateRequired };
        default:
            return { kind: 'unknown', requiresPaymentMethodUpdate: paymentMethodUpdateRequired };
    }
};
